import { defineStore } from "pinia";
import axiosInstance from "@/api/axios";

/**
 * 즐겨찾기(핀 고정) 메뉴 스토어 (2026-08-08)
 * - 백엔드 authz/favorites/ — 본인 즐겨찾기 CRUD.
 * - "내 업무" 화면 상단 위젯에서 사용: 자주 쓰는 메뉴만 바로가기로 노출.
 */
// 08-08: 처음엔 8개, 인라인 별표 토글로 개편하면서 20개로 상향했다가,
// "이제 8개 즐겨찾기는 제한은 필요 없는데"(사이먼) 피드백으로 상한 자체를 폐지.
// 서버(authz/views.py MenuFavoriteViewSet)도 동일하게 캡 없음 — 필요해지면 여기서만 값을 되살리면 됨.

export const useFavoritesStore = defineStore("favorites", {
  state: () => ({
    favorites: [],       // [{ id, menu_key, label, route, icon, order }]
    available: [],       // 추가 가능한 메뉴 후보 [{ key, label, route, icon, section, section_label }]
    loaded: false,
    loading: false,
    availableLoading: false,
    availableError: false,  // true면 "후보 없음"이 아니라 조회 자체가 실패한 것 — UI에서 구분 표시
  }),
  getters: {},
  actions: {
    async fetchFavorites(force = false) {
      if (this.loaded && !force) return;
      this.loading = true;
      try {
        const res = await axiosInstance.get("authz/favorites/");
        this.favorites = Array.isArray(res.data?.results)
          ? res.data.results
          : Array.isArray(res.data) ? res.data : [];
        this.loaded = true;
      } catch (err) {
        console.error("즐겨찾기 조회 실패:", err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAvailable() {
      this.availableLoading = true;
      this.availableError = false;
      try {
        const res = await axiosInstance.get("authz/favorites/available/");
        this.available = Array.isArray(res.data) ? res.data : [];
      } catch (err) {
        // 404/500 등 조회 실패를 "추가할 메뉴가 없음"과 절대 혼동하지 않게 별도 플래그로 구분.
        // (배포 직후 마이그레이션 미적용/백엔드 미재기동 시 이 상태가 뜬다 — 콘솔에 상태코드 남김)
        console.error("즐겨찾기 후보 조회 실패:", err?.response?.status, err);
        this.available = [];
        this.availableError = true;
      } finally {
        this.availableLoading = false;
      }
    },
    async addFavorite(menuKey) {
      const res = await axiosInstance.post("authz/favorites/", { menu_key: menuKey });
      await this.fetchFavorites(true);
      return res.data;
    },
    async removeFavorite(id) {
      await axiosInstance.delete(`authz/favorites/${id}/`);
      this.favorites = this.favorites.filter((f) => f.id !== id);
    },
  },
});
